<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Espaço Viver Bem</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile">
      <Multiselect
        v-model="payload.tipoServicoEspecialidade"
        :propsMultiselect="{
          placeholder: 'Serviços Ofertados',
          options: listaEspecialidades,
          'track-by': 'id',
          label: 'tipoServicoEspecialidade'
        }"
        v-show="clickSwitch"
        :errorMessage="
          mensagemDeErroServicos.outrosCentroMultiprofissionalViverBem
        "
      />
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="!outrosOpcao && clickSwitch"
    >
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="outrosOpcao && clickSwitch"
    >
      <div align="right" style="font-size: 15px; padding-top: 8px">
        Outros:
      </div>
    </unicom-coluna>
    <unicom-coluna sm="4" :class="espacamentoMobile">
      <unicom-campo-texto
        ladoIcone="direito"
        clickIcone
        colorPlaceholder="#9E9E9E"
        placeholder="Outros Serviços"
        :maxCaracteres="1500"
        v-model="payload.outro"
        :mensagemErro="
          errorsServicos.campoOutrosCentroMultiprofissionalViverBem
        "
        v-if="outrosOpcao && clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna sm="3" style="padding-top: 20px"> </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile" style="padding-top: 20px">
      <Multiselect
        v-model="payload.tipoServicoAbrangencia"
        :propsMultiselect="{
          placeholder: 'Programas Recomendados pela ANS',
          options: listaAbrangencias,
          'track-by': 'id',
          label: 'tipoServicoAbrangencia'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna sm="4" :class="espacamentoMobile" style="padding-top: 20px">
      <Multiselect
        v-model="payload.tipoServicoPublico"
        :propsMultiselect="{
          placeholder: 'Programas de promoção e prevenção à Saúde',
          options: listaPublicoAlvo,
          'track-by': 'id',
          label: 'tipoServicoPublico'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";

import SharedMixin from "@/views/RecursosPropriosQuestionarios/CentroMultiprofissional/componentes/CartaoInformacoesServicos/components/SharedMixin";
import ServicosMixin from "@/views/RecursosPropriosQuestionarios/CentroMultiprofissional/componentes/CartaoInformacoesServicos/ServicosMixin";

export default {
  mixins: [SharedMixin, ServicosMixin],
  components: {
    Multiselect
  },
  data() {
    return {
      payload: {
        tipoServico: "Espaço Viver Bem",
        tipoServicoEspecialidade: [],
        tipoServicoAbrangencia: [],
        tipoServicoPublico: [],
        outro: ""
      },
      listaEspecialidades: [],
      listaAbrangencias: [],
      outrosOpcao: false
    };
  },
  beforeMount() {
    this.inicializarEspecialidades();
    this.inicializarAbrangencias();
  },
  methods: {
    inicializarEspecialidades() {
      return this.getEspecialidades(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaEspecialidades = [...data];
        }
      });
    },
    inicializarAbrangencias() {
      return this.getAbrangencia(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaAbrangencias = [...data];
        }
      });
    }
  },
  watch: {
    "payload.tipoServicoAbrangencia": "emitir",
    "payload.tipoServicoPublico": "emitir",
    "payload.outro": "emitir",
    "payload.especialidadesOferecidas": "emitir",
    dadosServidor(newVal) {
      if (newVal.especialidades.length > 0) {
        newVal.especialidades.forEach(especialidade => {
          if (
            especialidade.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidade",
              especialidade.tipoServicoEspecialidade
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (servico.tipoServico.tipoServico === this.payload.tipoServico) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidades oferecidas",
              servico.especialidadesOferecidas
            );
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo("outro", servico.outro);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.abrangencias.length > 0) {
        newVal.abrangencias.forEach(abrangencia => {
          if (
            abrangencia.tipoServico.tipoServico === this.payload.tipoServico &&
            (abrangencia.tipoServicoAbrangencia || abrangencia.outroAbrangencia)
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "abrangencia",
              abrangencia.tipoServicoAbrangencia
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.servicosPublicos.length > 0) {
        newVal.servicosPublicos.forEach(servPubl => {
          if (
            servPubl.tipoServico.tipoServico === this.payload.tipoServico &&
            servPubl.tipoServicoPublico
          ) {
            this.clickSwitch = true;
            this.preencheCampo("servicoPublico", servPubl.tipoServicoPublico);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    },
    outrosOpcao(novoValor) {
      if (novoValor == true && !this.payload.outro) {
        this.errors.outros = true;
      }
      if (!novoValor) {
        this.errors.outros = false;
      }
    }
  }
};
</script>

<style scoped>
.unicom-linha {
  margin-bottom: 24px;
}
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
#titulo {
  font-size: 15px;
  padding-top: 8px;
  text-align: center;
}

.procedimentos {
  margin: 1rem 0;
}
</style>
